import { apiDate, boolean, number, optional, string, zodLess, ZodLessInfer } from '@kaiizen/zod-less';

export const ApiAudienceDocShareLinkStatusSchema = zodLess({
  hasActiveLink: boolean,
  expiresAt: optional(apiDate),
});
export type ApiAudienceDocShareLinkStatus = ZodLessInfer<typeof ApiAudienceDocShareLinkStatusSchema>;

export const ApiAudienceDocShareLinkCreateResponseSchema = zodLess({
  url: string,
  expiresAt: apiDate,
});
export type ApiAudienceDocShareLinkCreateResponse = ZodLessInfer<typeof ApiAudienceDocShareLinkCreateResponseSchema>;

export const ApiAudienceDocShareLinkRevokeResponseSchema = zodLess({
  revokedCount: number,
});
export type ApiAudienceDocShareLinkRevokeResponse = ZodLessInfer<typeof ApiAudienceDocShareLinkRevokeResponseSchema>;

export const getAudienceDocShareLinkStatusQueryKeyPrefix = () => 'audienceDocShareLinkStatus';
export const getAudienceDocShareLinkStatusQueryKey = (scanId?: string | null) => `${getAudienceDocShareLinkStatusQueryKeyPrefix()}/${scanId ?? ''}`;
